import React, { useState } from "react";
import { List, Typography, Tag, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { CloseCircleOutlined } from "@ant-design/icons";
import { orderActions } from "../../redux/reducers/order";
import { profileActions } from "../../redux/reducers/userProfile";
import instance from "../../utils/API";

const { Title } = Typography;

const Orders = () => {
  const { orders } = useSelector((state) => state.orders);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState();
  function successModal() {
    Modal.success({
      title: "Your membership is cancelled.",
      content: (
        <div>
          <p>Help us improve.</p>
          <p>Let us know how we can do better: info@odinplatform.com</p>
        </div>
      ),
      onOk() {
        dispatch(profileActions.getProfile(user.jwt));
        dispatch(orderActions.getOrders(user.jwt));
      },
    });
  }

  function errorModal(message) {
    Modal.error({
      title: "There was an issue",
      content: (
        <div>
          <p>{message}</p>
        </div>
      ),
      onOk() {},
    });
  }
  function getStatusTag(status) {
    switch (status) {
      case "paid":
        return (
          <Tag
            color="green"
            style={{ width: 70, marginRight: 25, textAlign: "center" }}
          >
            Paid
          </Tag>
        );
      case "active":
        return (
          <Tag color="green" style={{ width: 70, textAlign: "center" }}>
            Active
          </Tag>
        );
      case "trialing":
        return (
          <Tag color="green" style={{ width: 70, textAlign: "center" }}>
            Active
          </Tag>
        );
      case "pendingPayment":
        return (
          <Tag
            color="volcano"
            style={{ width: 70, marginRight: 25, textAlign: "center" }}
          >
            Pending
          </Tag>
        );
      case "incomplete":
        return (
          <Tag
            color="volcano"
            style={{ width: 70, marginRight: 25, textAlign: "center" }}
          >
            Incomplete
          </Tag>
        );
      case "incomplete_expired":
        return (
          <Tag
            color="volcano"
            style={{ width: 70, marginRight: 25, textAlign: "center" }}
          >
            Failed
          </Tag>
        );
      case "canceled":
        return (
          <Tag
            color="red"
            style={{ width: 70, marginRight: 25, textAlign: "center" }}
          >
            Canceled
          </Tag>
        );
      case "unpaid":
        return (
          <Tag
            color="red"
            style={{ width: 70, marginRight: 25, textAlign: "center" }}
          >
            Canceled
          </Tag>
        );
      default:
        return (
          <Tag
            color="magenta"
            style={{ width: 70, marginRight: 25, textAlign: "center" }}
          >
            Unknown
          </Tag>
        );
    }
  }

  const showModal = (item) => {
    setVisible(true);
    setSelectedOrder(item);
  };

  const handleOk = () => {
    setLoading(true);
    instance(user.jwt)
      .post("/orders/cancelsub", selectedOrder)
      .then(function (response) {
        successModal();
        setLoading(false);
        setVisible(false);
      })
      .catch(function (error) {
        errorModal("Whoops. There was an issue. Please contact support.");
        setLoading(false);
      });
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <Modal
        title="Are you sure ?"
        okText="Yes, I'm sure!"
        visible={visible}
        onOk={handleOk}
        confirmLoading={loading}
        onCancel={handleCancel}
      >
        <p>Are you sure you want to cancel subscription?</p>
        <p>Subscription will be cancelled immediately.</p>
      </Modal>
      <List
        header={
          <Title style={{ padding: 8 }} level={5}>
            Orders
          </Title>
        }
        bordered
        size="small"
        style={{
          borderRadius: 10,
          marginBottom: 25,
          boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
        }}
        dataSource={orders}
        renderItem={(item) => (
          <List.Item>
            {item.type == "course" ? (
              <b>{item.courseTitle}</b>
            ) : (
              <b>{item.serviceTitle}</b>
            )}
            <div>
              {getStatusTag(item.status)}
              {item.type == "membership" &&
                (item.status == "active" ||
                  item.status == "trialing" ||
                  item.status == "paid") && (
                  <CloseCircleOutlined
                    onClick={() => showModal(item)}
                    style={{ fontSize: "16px", color: "red" }}
                    theme="outlined"
                  />
                )}
            </div>
          </List.Item>
        )}
      />
    </>
  );
};

export default Orders;
